import { OCCASIONS } from '../../config/site';

export default function Occasions() {
  return (
    <section id="occasions" className="py-16 md:py-24 bg-cream scroll-mt-[132px]">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary text-center mb-12 md:mb-16">
          FOR EVERY OCCASION
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {OCCASIONS.map((o) => (
            <div key={o.id} className="text-center">
              <div className="bg-card-bg aspect-[4/3] mb-5 flex items-center justify-center overflow-hidden">
                {o.image ? (
                  <img
                    src={o.image}
                    alt={o.heading}
                    className={`w-full h-full object-cover ${o.imageClassName ?? ''}`}
                  />
                ) : (
                  <span className="text-text-muted/50 text-xs tracking-widest uppercase">Photo</span>
                )}
              </div>
              <h3 className="font-display text-2xl md:text-3xl tracking-[0.05em] text-text-primary mb-2">
                {o.heading}
              </h3>
              <p className="font-inter text-xs leading-relaxed text-text-muted max-w-xs mx-auto">
                {o.subheading}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
